// Image imports
import carmelGatPortrait from '../../../images/carmel-gat.jpeg';

export const carmelGatMemorial = {
  id: 14,
  name: 'Carmel Gat',
  category: 'community-leaders',
  images: {
    portrait: carmelGatPortrait
  },
  info: `

"There are a kind of small moments of happiness and assurance that everything can happen and we can bring everyone home back... but besides that, it's really horrible, horrific." - Or Gat, Carmel's brother

# Carmel Gat

![Carmel Gat](${carmelGatPortrait})
*Carmel Gat, whose life was dedicated to her family and community*

## A Daughter of Be'eri

Carmel Gat was 40 years old when she was taken hostage from her parents' home in Kibbutz Be'eri, where she had grown up and chosen to build her own life. On the morning of October 7th, 2023, as terror descended on the kibbutz, Carmel faced the unimaginable - her mother, Kineret, was murdered before her eyes, and she was dragged away by Hamas terrorists into Gaza.

Those who knew Carmel describe her as a woman with a gentle spirit and quiet determination. She had an innate ability to make others feel at ease, listening more than speaking, but when she did speak, her words carried weight and wisdom.

## A Life Cut Short

In the 11 months that followed her capture, Carmel's brother Or and the rest of her family campaigned tirelessly for her release. "We had moments of hope," Or told reporters in December 2023, knowing some hostages had been freed. But those small flickers of optimism were surrounded by the darkness of not knowing Carmel's fate.

Carmel should have been among those released in the first phase of the cease-fire agreement. Her name appeared in a July draft of the deal, giving her family renewed hope. But as negotiations stalled, time ran out for Carmel and five other hostages held with her.

## A Tragic Discovery

On August 31, 2024, Israeli forces recovered Carmel's body along with five others from a tunnel in Rafah, Gaza. According to Israeli officials, all six had been killed "shortly before" they were found. An autopsy revealed bullet wounds, evidence of their execution by their captors.

Her funeral was held in Kibbutz Be'eri, where she was laid to rest near her mother. The kibbutz that had once been her sanctuary had become the site of her family's deepest grief.

## Remembered in Love

At her funeral, Carmel was remembered not for how she died, but for how she lived - with kindness, resilience, and unwavering love for her family and community. Her friends spoke of how she found joy in simple pleasures: a beautiful sunset, a good book, a meaningful conversation.

"Carmel believed in human goodness," a childhood friend said in her eulogy. "Even in the darkest times, she looked for the light in others. That's who she was, and that's how she would want us to remember her."

Though her life was cut tragically short, Carmel Gat's memory lives on in the hearts of all who knew her and in the continued fight to bring all hostages home.

May her memory be a blessing, and may her spirit find the peace that was taken from her in life.

`
};